import { Button, ProjectIcon } from '@cfs-fixings/shared'
import { DesignResource, ProjectWithOrderedDesignsResource } from '@/api/serverApi'
import DesignGridCard from '@/components/grid-items/DesignGridCard'
import { Link, useNavigate } from 'react-router-dom'

type PropTypes = {
  projects?: ProjectWithOrderedDesignsResource[]
  footerElements?: React.ReactNode[]
  dropdown?: (design: DesignResource) => React.ReactNode
}

function GroupedDesignGridView ({ projects, footerElements, dropdown }: PropTypes) {
  const navigate = useNavigate()

  return (
    <ul className="w-full">
      {
        projects?.map((project) => (
          <li key={project.id} className="mb-10">
            <div className="flex flex-row items-center gap-[5px] mb-[23px] px-2.5">
              <ProjectIcon className="h-[18px] w-[18px]" />
              <p className="font-semibold leading-[19.2px]">{project.name}</p>
            </div>
            <ul className="w-full flex flex-row items-center justify-start flex-wrap">
              {
                project.designs?.map((design) => (
                  <Link to={`/designs/${design.id}`} key={design.id}>
                    <DesignGridCard design={design} dropdown={dropdown?.(design)} />
                  </Link>
                ))
              }
            </ul>
            {
              project.has_more_designs
                && <div className="flex items-center justify-center mt-6">
                  <Button
                    variant={'secondary'}
                    onClick={() => navigate(`/projects/${project.id}`)}
                  >
                    See More
                  </Button>
                </div>
            }
          </li>
        ))
      }
      {
        ...(footerElements ?? [])
      }
    </ul>
  )
}

export default GroupedDesignGridView
